import { GiftOpenIcon } from './GiftOpenIcon';

/**
 * author: Colton Wiscombe
 * id 04D976AC-875C-42F1-A9F6-B86FDAAD6990
 * name gift-open
 * version: 5.9.55
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gift-open.svg
 * tags
 * - Holiday 
 */
export const PresentOpenIcon = GiftOpenIcon;
export default PresentOpenIcon